import React from "react";
import RankBonusGrid from "./RankBonusGrid";
import RuleItemView from "./RuleItemView";
import { RuleModuleType } from "../constants/constants";
import { RuleModuleContext } from "../contexts/RuleModuleContext";
import SpendableImprovements from "./SpendableImprovements";
import { RuleItemContext } from "../contexts/RuleItemContext";
import { CharacterSheetContext } from "../contexts/CharacterSheetContext";
import { SpendingOnType } from "../interfaces/SpendablesForModules";

export default () => {
  const {
    statsName,
    statsKey,
    getStatDefinitions,
    dataTest,
    moduleType,
  } = React.useContext(RuleModuleContext);
  const { showSources, showAllAlerts, alertLevel } = React.useContext(
    CharacterSheetContext
  );

  return (
    <RankBonusGrid
      ruleModuleType={RuleModuleType.ItemOnly}
      name={statsName}
      testKey={`stats-${dataTest()}-${moduleType}`}
    >
      <SpendableImprovements
        moduleKey={statsKey}
        spendingOn={SpendingOnType.STATS}
      />
      {getStatDefinitions().ruleItems.map((item, i) => (
        <CharacterSheetContext.Provider
          value={{
            showSources,
            showAllAlerts,
            alertLevel,
            characterEditMode: false,
            adminMode: false,
          }}
          key={`stat-${i}`}
        >
          <RuleItemContext.Provider value={item}>
            <RuleItemView moduleTypeOverride={RuleModuleType.ItemOnly} />
          </RuleItemContext.Provider>
        </CharacterSheetContext.Provider>
      ))}
    </RankBonusGrid>
  );
};
